import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Broadcast, ArrowsClockwise, CheckCircle, XCircle } from '@phosphor-icons/react';

export default function WebhookMonitorPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    API.get('/webhooks').then(r => setEvents(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="webhook-monitor-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="page-heading mb-0">
          <Broadcast size={24} className="inline mr-2 text-[#002FA7]" />
          Webhook Monitor
        </h1>
        <button className="btn btn-secondary btn-sm" onClick={load} disabled={loading} data-testid="refresh-webhooks">
          <ArrowsClockwise size={14} className={loading ? 'animate-spin' : ''} /> Verversen
        </button>
      </div>

      <div className="section-card">
        <div className="section-body">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width: 160 }}>Tijdstip</th>
                <th style={{ width: 100 }}>Provider</th>
                <th style={{ width: 80 }}>Status</th>
                <th style={{ width: 120 }}>Event</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {events.map((e, i) => (
                <tr key={i}>
                  <td className="text-xs font-mono text-gray-500">
                    {e.tijdstip ? new Date(e.tijdstip).toLocaleString('nl-BE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '-'}
                  </td>
                  <td>
                    <span className="text-xs font-semibold px-2 py-0.5 bg-[#002FA7]/10 text-[#002FA7]">{e.provider}</span>
                  </td>
                  <td>
                    {e.success ? (
                      <CheckCircle size={16} weight="bold" className="text-[#059669]" />
                    ) : (
                      <XCircle size={16} weight="bold" className="text-[#DC2626]" />
                    )}
                  </td>
                  <td className="text-xs font-medium">{e.event_type || '-'}</td>
                  <td className="text-xs text-gray-500 truncate max-w-xs">{e.details || '-'}</td>
                </tr>
              ))}
              {events.length === 0 && (
                <tr><td colSpan="5" className="text-center text-gray-400 py-12">
                  Geen webhook events. Events verschijnen hier wanneer Stripe of Mollie een betaling meldt.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
